export const phonePattern = /^[(][0-9]{3}[)][-\s.][0-9]{3}[-\s.][0-9]{4,6}$/
export const zipPattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/
export const dobPattern = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4}$/
